document.addEventListener("DOMContentLoaded", function () {
  document.querySelector("#voiceDateSelect").addEventListener("change", function (event) {
    location.href = "?selected_date=" + event.target.value;
  });
});
